import { render, staticRenderFns } from "./MenuLanguageNavDropdown.vue?vue&type=template&id=ab904548&"
import script from "./MenuLanguageNavDropdown.vue?vue&type=script&lang=js&"
export * from "./MenuLanguageNavDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports